import axios from "axios";

const LeaveConfigService = {
  // Add (no typeId) or edit (with typeId) a leave type
  async saveLeaveType(t) {
    try {
      const params = new URLSearchParams({
        p_typeCode: t.code,
        p_typeName: t.name,
        p_isActive: t.active ? "A" : "I",
        p_displayOrder: String(t.displayOrder),
        p_typeIsPaid: t.paid ? "Y" : "N",
        p_userId: t.userId,
      });
      if (t.id) params.append("p_typeId", t.id);
      const response = await axios.post(`/LeaveType/PostLeaveType?${params.toString()}`);
      console.log("[LeaveConfig] saveLeaveType response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveConfig] Error saving leave type:", error);
      throw error;
    }
  },

  async getPolicies() {
    try {
      const response = await axios.get("/LeavePolicy/GetLeavePolicyList");
      console.log("[LeaveConfig] getPolicies response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveConfig] Error fetching policies:", error);
      throw error;
    }
  },

  // Add (no id) or edit (with id) a policy: both use the same PostLeavePolicy route
  async savePolicy(p) {
    try {
      const params = new URLSearchParams({
        p_empType: String(p.employeeTypeId),
        p_leaveTypeId: String(p.leaveTypeId),
        p_anAllocate: String(p.days),
        p_mothlyEarns: String(p.keep.monthlyEarn),
        p_quarter1: String(p.keep.quarter1),
        p_quarter2: String(p.keep.quarter2),
        p_quarter3: String(p.keep.quarter3),
        p_quarter4: String(p.keep.quarter4),
        p_prorata: p.keep.prorata,
        p_carry: p.keep.carry,
        p_maxcarry: String(p.keep.maxCarry),
        p_isActive: p.active ? "A" : "I",
        p_CalMethod: p.keep.calcMethod,
        p_userId: p.userId,
      });
      if (p.id) params.append("p_policyId", String(p.id));
      if (p.from) params.append("p_effectiveStartDate", p.from);
      if (p.to) params.append("p_effectiveEndDate", p.to);
      const response = await axios.post(`/LeavePolicy/PostLeavePolicy?${params.toString()}`);
      console.log("[LeaveConfig] savePolicy response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveConfig] Error saving policy:", error);
      throw error;
    }
  },

  async getEmployeeTypes() {
    try {
      const response = await axios.get("/EmployeeCategory/GetEmployeeCategories");
      console.log("[LeaveConfig] getEmployeeTypes response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveConfig] Error fetching employee types:", error);
      throw error;
    }
  },
};

export default LeaveConfigService;